module.exports = __webpack_public_path__ + "img/eyeliner.4a947cdc.svg";